import React, { Component } from "react";
import Select from "react-select";

class FormUpdate extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div>
                <div className="card">
                    <div className="card-body">
                        <div className="row">
                            <div className="form-group col-12">
                                <label>Link</label>
                                <input
                                    type="text"
                                    name="link"
                                    value={this.props.link}
                                    onChange={this.props.handleLinkChanged}
                                    style={{ padding: "3px" }}
                                    className="form-control"
                                />
                            </div>
                            <div className="form-group col-12">
                                <label>Portal</label>
                                <input
                                    type="text"
                                    name="portal"
                                    value={this.props.portal}
                                    onChange={this.props.handlePortalChanged}
                                    style={{ padding: "3px" }}
                                    className="form-control"
                                />
                            </div>
                            {/* <div className="form-group col-6">
                                <label>Tipo</label>

                                <Select
                                    value={this.props.type}
                                    selected={this.props.type}
                                    placeholder={this.props.type}
                                    isMulti={false}
                                    onChange={this.props.handleTypeChanged}
                                    options={[
                                        { value: "", label: "Selecione" },
                                        {
                                            value: "Horizontal",
                                            label: "Horizontal",
                                        },
                                        {
                                            value: "Vertical",
                                            label: "Vertical",
                                        },
                                        {
                                            value: "Comercial",
                                            label: "Comercial",
                                        },
                                        {
                                            value: "Hotel",
                                            label: "Hotel",
                                        },
                                    ]}
                                />
                            </div> */}
                            <div className="form-group col-12">
                                <label>Observação</label>
                                <input
                                    type="text"
                                    name="observacao"
                                    value={this.props.observacao}
                                    onChange={
                                        this.props.handleObservacaoChanged
                                    }
                                    style={{ padding: "3px" }}
                                    className="form-control"
                                />
                            </div>
                            <div className="form-check col-3">
                                <label className="form-check-label">
                                    <input
                                        className="form-check-input"
                                        checked={this.props.phone_number}
                                        onChange={
                                            this.props
                                                .handlePhoneNumberChanged
                                        }
                                        type="checkbox"
                                        value="true"
                                    />
                                    <span className="form-check-sign"></span>
                                    Ligação
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default FormUpdate;
